document.addEventListener('click', function (e) {
  const trigger = e.target.closest('a[href="#koalafi-prequalify"], button[data-koalafi-prequalify]');
  if (!trigger) return;

  e.preventDefault();
  if (window.ChargeAfter?.apply?.present) {
    ChargeAfter.apply.present();
  } else {
    console.error('ChargeAfter/Koalafi SDK not loaded or missing apply.present().');
  }
});
